import React, { useState } from 'react';
import InteractionContainer from '../../partials/InteractionContainer/InteractionContainer.jsx';
import Scroll from '../../partials/Scroll/Scroll';
import Button from '../../partials/Button'
import './VerticalTabs.scss'

import Media from '../../partials/Media/index.js';

import Instructions from '../../partials/Instructions/Instructions.jsx';
import HTMLContent from '../../partials/HTMLContent/index';


const VerticalTabs = props => {
  const { data } = props;
  const [currentTab, setCurrentTab] = useState(0);
  const [visited, setVisited] = useState(data.activity.subTabs.map((tab, index) => index == currentTab));

  return (
    <div className="Vertical-Tabs">
      <InteractionContainer withFrame={true} breadcrumbs={props.breadcrumbs} >
        <div className="back-btn-container">
          <Button variant='back' text="Back" onClick={props.goBackToPreviousSegment} />
        </div>
        <Instructions body={data.config.instruction} />

        {/* <div className="tab-content">
          <ul className="subtab-list">
            <Scroll>
              {
                data.activity.subTabs.map((subTab, subTabIndex) => (
                  <li key={`subtab-item-${subTabIndex}}`}
                    className={`subtab-item ${subTabIndex === currentTab ? 'active' : ''}`}
                    onClick={() => { setCurrentTab(subTabIndex) }}>
                    {subTab.tabText}
                  </li>
                ))
              }
            </Scroll>
          </ul>
          <div className="subtab-body">
            {data.activity.subTabs[currentTab] &&
              <Scroll>
                <div className="container">
                  <div className="body-container"><HTMLContent html={data.activity.subTabs[currentTab].text}></HTMLContent></div>
                  <img src={data.activity.subTabs[currentTab].img.src} alt={data.activity.subTabs[currentTab].img.overlayText} width="100%" />
                </div>
              </Scroll>
            }
          </div>
        </div> */}

        <div className="tab-content">

          <ul className="subtab-list">
            <Scroll>
              {
                data.activity.subTabs.map((subTab, subTabIndex) => (
                  <li key={`subtab-item-${subTabIndex}}`}
                    className={`subtab-item ${subTabIndex === currentTab ? 'active' : ''}`}
                    onClick={() => { 
                      setCurrentTab(subTabIndex); 
                      setVisited(visited.map((tab, index) => subTabIndex === index ? true : tab)) 
                    }}>
                    {subTab.tabText}
                  </li>
                ))
              }
            </Scroll>
          </ul>
          
          <div className="subtab-body">
            {data.activity.subTabs[currentTab] &&
              <Scroll>
                <div className="container">
                  <div className="body-container"><HTMLContent html={data.activity.subTabs[currentTab].text}></HTMLContent></div>
                  {(data.activity.subTabs[currentTab].img.src != null && data.activity.subTabs[currentTab].img.src !== '')?<Media src={data.activity.subTabs[currentTab].img.src}
                    alt={data.activity.subTabs[currentTab].img.overlayText} width="100%" />:<></>}
                </div>
              </Scroll>
            }
          </div>
        </div>
        <div className="button-container">
          {
            visited.every(tab => tab) && <Button text="Next" onClick={() => props.onComplete()} />
          }
        </div>
      </InteractionContainer>
    </div>
  )
}

export default VerticalTabs;